import i18n, { initI18n } from "@/shared/i18n";
import { modules } from "./modules";

initI18n(Object.values(modules).map((m) => m.strings));

export default i18n;
